import {ImageRequestParams} from "../../../../infrastructure/models/params/image-request-params";
import {EventTypeViewModel} from "./event-type-view-model";
import {IMAGE_DEFAULT_FORMATS} from "../../../../core/app/consts";

export class EventTypeImageRequestParams extends ImageRequestParams {
  subTypeId: Number;
  id: Number;

  constructor(model: EventTypeViewModel, width: Number = 32, height: Number = 32, ratio: Number) {
    super({alt: model.alt, title: model.title, width, height,ratio});

    this.id = model.id;
    this.resourceName = `NewBrand25/EventType/`;
    this.subTypeId = model.subTypeId;
    this.fallbackResourceId = model.id;
  }

  get params(): * {
    return `${super.params},d_NewBrand25:EventTypes:${this.theme}:${this.fallbackResourceId}.svg`;
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.SVG;
  }

  get pathPostfix(): String {
    return super.pathPostfix + `${this.theme}/${this.id}`;
  }
}
